import { TextField } from '@fluentui/react/lib/TextField';
import { textProp } from 'global/Application';
import { IStringValue } from 'model/FlexibleAttributeModel';
import React, { useState } from 'react';

interface IProps {
    [key: string]: any;
    fieldValueOnChange?: (event: any, value: IStringValue) => void;
    defaultFieldValue: IStringValue;
}

const MultiTextField: React.FC<any> = (props: IProps) => {

    const defaultValue = props.defaultFieldValue ? props.defaultFieldValue.value : props.defaultValue;
    const [val, setVal] = useState(defaultValue);

    if (props.disabled)
        return <TextField
            label={props.label}
            multiline
            rows={4}
            styles={{ fieldGroup: { border: textProp.textStyles.root.border } }}
            defaultValue={defaultValue ?? "---"}
            readOnly={true}
        />


    return <TextField
        label={props.label}
        // onChange={props.fieldValueOnChange ? fieldValueOnChange : handleChange}
        multiline
        rows={4}
        onChange={(event, newValue) => { setVal(newValue) }}
        defaultValue={defaultValue}
        disabled={props.disabled}
        maxLength={4000}
        onBlur={(event) => {
            const value: IStringValue = {
                type: 'string',
                value: val!
            }
            props.fieldValueOnChange?.(event, value);
        }}
        {...props.other}
    />
}

export default MultiTextField